module.exports = __webpack_public_path__ + "static/img/illustratepic_02.0f81131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ja/illustratepic_02.png
// module id = zgEO
// module chunks = 1